import React from 'react';
import { CTA_LINKS } from '../constants/ctaLinks';
import { trackAppinesCtaClicked } from '../utils/analyticsEvents';

interface AppinesBannerProps {
  className?: string;
  professionId?: string;
}

export default function AppinesBanner({ className = '', professionId = 'infirmier' }: AppinesBannerProps) {
  const cvSubmissionLink = professionId === 'infirmier' 
    ? CTA_LINKS.INFIRMIER.CV_SUBMISSION 
    : CTA_LINKS.GENERAL.MAIN_WEBSITE;

  return (
    <div className={`md:mx-auto md:max-w-5xl md:static fixed top-0 left-0 right-0 z-40 md:z-auto ${className}`}>
      <div className="bg-gradient-to-r from-appines-dark to-appines-dark md:rounded-xl shadow-sm overflow-hidden w-full">
        <div className="px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-8">
          <div className="flex items-center justify-between gap-2 sm:gap-3">
            {/* Logo et contenu */}
            <div className="flex items-center gap-2 sm:gap-3 flex-1">
              <div className="w-6 h-6 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-appines-white rounded-full p-1 sm:p-2 flex-shrink-0">
                <img 
                  src="/logo-appines.png" 
                  alt="App'Ines" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-left flex-1 min-w-0">
                <h2 className="text-appines-white font-medium text-sm sm:text-base md:text-lg leading-tight">
                  <span className="hidden sm:inline">On simule tes revenus, </span>
                  <span className="text-appines-main">on te trouve aussi un job IDE</span>
                </h2>
              </div>
            </div>
            
            {/* CTA */}
            <div className="flex-shrink-0">
              <a
                href={cvSubmissionLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackAppinesCtaClicked('appines_banner', cvSubmissionLink)}
                className="inline-flex items-center gap-1 px-3 py-1.5 sm:px-4 sm:py-2.5 md:px-6 md:py-3 bg-appines-main hover:bg-appines-darker text-appines-white font-medium rounded sm:rounded-md transition-colors duration-200 text-sm sm:text-base whitespace-nowrap"
              aria-label="Envoyer votre CV à App'Ines pour trouver un emploi IDE"
              >
                <span className="hidden sm:inline">Envoyer mon CV</span>
                <span className="sm:hidden">CV</span>
                <span>👉</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}